<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>值日备注菜单使用说明:<br>
          <span>1、备注内容设定为所有值日表公用一条信息。</span><br>
          <span>2、备注内容目前只支持文本格式。</span><br>
        </h5>
      </div>
    </div>

    <!-- 动态按钮生成 -->
    <div class="content_edit">
      <pre-button @button-event="select_method" :pre_control="control" />
      <div class="content_btn">
        <div class="content_btn_item">
          <button @click="look_note">备注说明</button>
          <slot name="pre_base_button"></slot>
        </div>
      </div>
    </div>

    <div class=" tab-row" >
       <textarea style="min-width: 600px;min-height: 480px;width: 100%;" v-model="indata"></textarea>
    </div>


  </div>
</template>
<!-- 单项编辑 -->
<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect,
    Method_ComplexUpdate
  } from '@/utils/loadhttpdata.js';

  import {
    base_encode,
    base_decode
  } from "@/utils/base64.js";

  export default {
    components: {
      "pre-button": () => import("../per_old/pre_btn_control_easy.vue")
    },
    data() {
      return {
        element_loading: false,
        control: '',
        row_id: '',
        sys_date: '',

        parm: [], //参数结构
        parm_th: [], //标题
        key_word: "",
        kw1: '',
        kw2: '',
        kw3: '',

        max_row: 1,

        indata:''
      };
    },
    created() {
      console.log('加载');
      this.load_data();
    },
    methods: {
      load_data: function() {
        console.log('初始化!');
        let init_data = '';
        init_data = JSON.stringify({
          "control": "	xz_ps_dutynote",
          "sel_action": 'exp_per_note',
          "upd_action": 'p4_duty_note',
          "key_word": '',
          "parm": [{
            "name": "备注",
            "val": "",
            "key": "p_note",
            "type": "textarea",
            "class": "long5",
            "p": "1",
            "x": '1',
          }]
        });

        this.max_row = [];
        for (let i = 1; i < 5; i++) {
          let o = {};
          o.row = i;
          this.max_row.push(o);
        }
        this.indata='';

        let r = JSON.parse(init_data);
        this.control = r.control;
        this.sel_action = r.sel_action;
        this.upd_action = r.upd_action;
        this.key_word = r.key_word;
        this.parm = r.parm;
        this.parm_th = r.parm_th;
        this.loadMethod();
      },
      NextTickName: function(key) {
        // console.log('key=' + key);
        return 'pre' + key;
      },
      checkJson: function(d) {
        let temp = '';
        temp = JSON.stringify(d)
        return temp;
      },
      refresh_view_edit: function(d, type) {
        // console.log(d);
        for (let i = 0; i < this.parm.length; i++) {
          if (this.parm[i].key == d.key) {
            if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
              this.parm[i].val = d.val;
              this.parm[i].sel_name = d.sel_name;
              break;
            } else {
              this.parm[i].val = d.val;
              break;
            }
          }
        }

        if (type == 'save') {
          this.fun_upd('_add');
        }
      },
      look_note: function() {
        //收缩区 收放设置
        this.show_note = this.show_note ? false : true;
        if (this.show_note) {
          $("#notice").slideDown("slow");
        } else {
          $("#notice").slideUp("slow");
        }
      },
      refresh_data: function() {

      },
      select_method: function(type) {
        switch (type) {
          case 'new':
            this.data_clear();
            break;
          case 'add':
            // 不能在方法里传  this.变量
            this.fun_upd('_add');
            break;
          case 'upd':
            this.fun_upd('_upd');
            break;
          case 'del':
            this.fun_upd('_del');
            break;
          case 'sel':
            this.refresh_data();
            break;
          case 'sub':
            this.fun_upd('_sub');
            break;
          case 'bad':
            this.fun_bad('_bad');
            break;
          case 'exl':
            this.build_exceldata();
            break;
          default:
            this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
            break;
        }
      },
      data_clear: function() {
        this.row_id = '';
        this.sys_date = '';

        for (let j = 0; j < this.parm.length; j++) {
          if (this.parm[j].type == 'select') {
            this.parm[j].val = '';
            this.parm[j].sel_name = '';
          } else {
            this.parm[j].val = '';
          }

        }
      },
      loadMethod: function() {
        this.$post(
          api.http_method, Method_EasySelect('data_' + this.sel_action)
        ).then(res => {
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data[0];
            // console.log(t);
            this.row_id = t.id;
            this.sys_date = t.sys_date;
            this.indata = base_decode(t.p_note);
            // this.indata = t.p_note;
          }
        });
      },
      fun_upd: function(type) {
        let d = [];
        d.push(base_encode(this.indata));


        let r = (Math.random() + '').substring(0, 8);
        // console.log(d);
        let temp_data = '';
        temp_data = Method_ComplexUpdate('data_' + this.upd_action + type, this.row_id, d, r);

        this.$post(
          api.http_method, temp_data
        ).then(res => {
          this.element_loading = false;
          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });

            this.loadMethod();

          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });

      }

    }
  };
</script>
<style scoped>
</style>
